import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | sending | sent
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setState("sending");
        try {
            await api.post("/auth/forgot-password", { email });
            setState("sent");
        } catch (err) {
            setState("idle");
            setError(formatApiError(err.response?.data?.detail) || "Please try again.");
        }
    };

    return (
        <main className="container-page py-16 max-w-md fade-up" data-testid="forgot-password-page">
            <Link to="/login" className="inline-flex items-center gap-2 text-[#515B57] hover:text-[#2D5D4E] mb-6" data-testid="forgot-back-login">
                <ArrowLeft className="w-4 h-4" /> Back to sign in
            </Link>
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-2" style={{ fontFamily: "Outfit" }}>
                Forgot your password?
            </h1>
            <p className="text-[#515B57] text-lg mb-8">
                Enter the email you signed up with. We&apos;ll send a reset link.
            </p>

            {state === "sent" ? (
                <div
                    className="card-rw p-6"
                    style={{ borderLeft: "6px solid #2D5D4E" }}
                    data-testid="forgot-sent"
                >
                    <div className="flex items-start gap-3">
                        <Mail className="w-5 h-5 text-[#2D5D4E] mt-0.5" strokeWidth={1.6} />
                        <div>
                            <h2
                                className="text-xl font-medium text-[#1C2321] mb-1"
                                style={{ fontFamily: "Outfit" }}
                            >
                                Check your inbox
                            </h2>
                            <p className="text-[#515B57] leading-relaxed">
                                If an account exists for <strong className="text-[#1C2321]">{email}</strong>, a
                                reset link is on its way. It expires in an hour.
                            </p>
                            <p className="text-sm text-[#819888] mt-3">
                                Didn&apos;t get anything? Check spam, or ask us at instructor@liftupreading.com.
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
                    <div>
                        <label className="block text-sm font-medium text-[#1C2321] mb-2">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                            data-testid="forgot-email-input"
                            className="w-full px-4 py-3 rounded-lg border border-[#E5E7E2] bg-white text-[#1C2321] text-lg focus:outline-none focus:ring-2 focus:ring-[#2D5D4E]"
                        />
                    </div>
                    {error && (
                        <p className="text-[#B24C4C] text-base" data-testid="forgot-error">{error}</p>
                    )}
                    <button
                        type="submit"
                        disabled={state === "sending"}
                        data-testid="forgot-submit-button"
                        className="w-full py-3.5 rounded-lg bg-[#2D5D4E] text-[#FAF9F6] text-lg font-medium hover:bg-[#1F4237] transition-colors disabled:opacity-50"
                    >
                        {state === "sending" ? "Sending…" : "Send reset link"}
                    </button>
                </form>
            )}
        </main>
    );
}
